import { render, staticRenderFns } from "./AddFNAC.vue?vue&type=template&id=f67155dc&scoped=true"
import script from "./AddFNAC.vue?vue&type=script&lang=js"
export * from "./AddFNAC.vue?vue&type=script&lang=js"
import style0 from "./AddFNAC.vue?vue&type=style&index=0&id=f67155dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67155dc",
  null
  
)

export default component.exports